import {
  PUSH_NOTIFICATIONS_FETCH_SUCCESS,
  PUSH_NOTIFICATIONS_TOPICS_FETCH_SUCCESS
} from '../constant/actionType';
import {
  getPushNotifications,
  getPushNotificationsTopics,
  createPushNotification,
  createPushNotificationForUsers
} from '../services/napi';

export function getPushNotificationsAction() {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await getPushNotifications(projectId);
    dispatch({
      data: response.data.pushNotifications,
      type: PUSH_NOTIFICATIONS_FETCH_SUCCESS
    });
  };
}

export function getPushNotificationsTopicsAction() {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await getPushNotificationsTopics(projectId);
    dispatch({
      data: response.data.topics,
      type: PUSH_NOTIFICATIONS_TOPICS_FETCH_SUCCESS
    });
  };
}

export function createPushNotificationAction(title, text, topic, userIds, data, onSuccess) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;

    if ((userIds && userIds.length) || data?.type === 'News') {
      const body = { data, text, title, userIds };
      await createPushNotificationForUsers(projectId, body);
    } else {
      const body = { text, title, topic };
      await createPushNotification(projectId, body);
    }
    onSuccess();
  };
}
